import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { ErrorMessage } from '../../../interfaces';
import { FirstErrorMessagePipe } from '../../pipes';

@Component({
  selector: 'hmax-input-email',
  standalone: true,
  templateUrl: './input-email.component.html',
  styleUrls: ['./input-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CapitalizePipe,
    CommonModule,
    FirstErrorMessagePipe,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
})
export class InputEmailComponent implements OnInit {
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() icon = 'mat_outline:email';
  @Input() iconSize = 5;
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() autocomplete = 'email';

  errorMessages: ErrorMessage[] = [
    { error: 'required', message: 'required-field' },
    { error: 'email', message: 'invalid-email' },
    { error: 'invalid', message: 'invalid-email' },
    { error: 'alreadyInUse', message: 'email-already-registered' },
    { error: 'deposable', message: 'invalid-email' },
    { error: 'requireAtLeastOneField', message: 'require-at-least-one-field' },
  ];

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }

  ngOnInit(): void {
    // Carregar controlName com o label se não houver controlName definido
    this.controlName = this.controlName ?? this.label;
  }
}
